<template>
	<div class="kun_loading23_container">
		<div class="loader"></div>
	</div>
</template>


<script>
	export default {
		name: "kun_loading23",
	}
</script>


<style scoped>
	.kun_loading23_container {
		display: flex;
		justify-content: center;
		align-items: center;

	}

	.loader {
		display: block;
		--height-of-loader: 4px;
		--loader-color: #0071e2;
		width: 130px;
		height: var(--height-of-loader);
		border-radius: 30px;
		background-color: rgba(0, 0, 0, 0.2);
		position: relative;
	}

	.loader::before {
		content: "";
		position: absolute;
		background: var(--loader-color);
		top: 0;
		left: 0;
		width: 0%;
		height: 100%;
		border-radius: 30px;
		animation: moving 1s ease-in-out infinite;;
	}

	@keyframes moving {
		50% {
			width: 100%;
		}

		100% {
			width: 0;
			right: 0;
			left: unset;
		}
	}
</style>
